import { Cascader, Form, Input } from 'antd';
import { useEffect, useState } from 'react';
import { handleTeacherArea } from '@/api/teacherPerformance';
import { getRules, getMessage } from './util';

const CascaderForm = (props) => {
    let [options, setOptions] = useState([]),
        [loading, setLoading] = useState(true),
        { setting, updated, desc, form, field_type } = props;
    const disabled = updated !== 0;
    let multiple = setting.type !== 'single';
    const handleTeacherAreaFunc = async (isLeaf, parent_code) => {
        const { success, data } = await handleTeacherArea({ parent_code: parent_code });
        if (success && data) {
            const children = data.map((item) => {
                return {
                    label: item['name'],
                    value: item['code'],
                    isLeaf: isLeaf
                };
            });
            return children;
        }
    },
     handleInitial = async () => {
        // setting['data_source'] = 'province_city';
        let provinces = await handleTeacherAreaFunc(setting['data_source'] === 'province');
        setTimeout(async () => {
            const areaValue = form?.getFieldValue(props.en_name),
             areaName = form?.getFieldValue(`${props.en_name}_name`);
            if (areaValue?.length === 2) {
                let province = { label: areaName[0], value: areaValue[0], isLeaf: false };
                province.children = await handleTeacherAreaFunc(false, areaValue[0]);
                for (let index = 0; index < provinces.length; index++) {
                    if (provinces[index]['value'] === province['value']) {
                        provinces[index] = province;
                        break;
                    }
                }
            } else if (areaValue?.length === 3) {
                let province = { label: areaName[0], value: areaValue[0], isLeaf: false };
                province.children = await handleTeacherAreaFunc(false, areaValue[0]);
                let city = { label: areaName[1], value: areaValue[1], isLeaf: false };
                city.children = await handleTeacherAreaFunc(true, areaValue[1]);
                for (let index = 0; index < province.children.length; index++) {
                    if (province.children[index]['value'] === city['value']) {
                        province.children[index] = city;
                        break;
                    }
                }
                for (let index = 0; index < provinces.length; index++) {
                    if (provinces[index]['value'] === province['value']) {
                        provinces[index] = province;
                        break;
                    }
                }
            }
            setOptions(provinces);
            setLoading(false);
        }, 1000);
    },
     loadData = async (selectedOptions) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        let isLeaf = true;
        if (setting['data_source'] === 'province_city_district' && selectedOptions.length === 1) {
            isLeaf = false;
        }
        const children = await handleTeacherAreaFunc(isLeaf, targetOption['value']);
        targetOption.children = children;
        setOptions([...options]);
    },
     handleCascaderChange = (value, selectedOptions) => {
        const nameArray = selectedOptions?.map((option) => {
            return option.label;
        });
        form?.setFieldsValue({ [`${props.en_name}_name`]: nameArray });
    };

    useEffect(() => {
        handleInitial();
    }, []);
    return (
        <>
            <Form.Item key={props.field_id} label={props.label === undefined ? props.name : props.label} name={props.en_name} rules={getRules(props)}>
                <Cascader
                    loading={loading}
                    disabled={disabled}
                    multiple={multiple}
                    options={options}
                    placeholder={desc || getMessage(field_type)}
                    loadData={loadData}
                    changeOnSelect
                    onChange={handleCascaderChange}
                    // displayRender={(labels) => labels.join('')}
                ></Cascader>
            </Form.Item>
            <Form.Item name={`${props.en_name}_name`} style={{ display: 'none' }}>
                <Input hidden></Input>
            </Form.Item>
        </>
    );
};
export default CascaderForm;
